"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateToken = void 0;
var StateManager_1 = require("./StateManager");
/**
 * State token
 */
var StateToken = /** @class */ (function () {
    function StateToken(pParam1, pLoadScreen) {
        var pTransitionSteps = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            pTransitionSteps[_i - 2] = arguments[_i];
        }
        if (pParam1 instanceof Object) {
            this.stateId = pParam1.id;
            this.data = pParam1.data;
        }
        else {
            this.stateId = pParam1;
        }
        this.loadScreen = pLoadScreen;
        this.transitionSteps = pTransitionSteps;
    }
    /**
     * A transition specifically for the splash screen.
     * @description Steps:
     * 1. LoadAssets
     * 2. AttachNewBehind
     * 3. HideLoadScreen
     * 4. AnimNewIn
     */
    StateToken.TRANSITION_FIRST_VIEW = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewBehind,
        StateManager_1.TransitionStep.HideLoadScreen,
        StateManager_1.TransitionStep.AnimNewIn,
    ];
    /**
     * A simple interstitial transition.
     * @description Steps:
     * 1. ShowLoadScreen
     * 2. RemoveCurrent
     * 3. UnloadAssets
     * 4. LoadAssets
     * 5. AttachNewInFront
     * 6. HideLoadScreen
     * 7. AnimNewIn
     * 8. UnloadUnusedAssets
     */
    StateToken.TRANSITION_SIMPLE_INTERSTITIAL = [
        StateManager_1.TransitionStep.ShowLoadScreen,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewInFront,
        StateManager_1.TransitionStep.HideLoadScreen,
        StateManager_1.TransitionStep.AnimNewIn,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Animate out old state and then animate in new state with assets loaded first.
     * @description Steps:
     * 1. LoadAssets
     * 2. AnimCurrentOut
     * 3. RemoveCurrent
     * 4. UnloadAssets
     * 5. AttachNewInFront
     * 6. AnimNewIn
     * 7. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_SEQUENTIAL_PRE_ASSETS = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AnimCurrentOut,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.AttachNewInFront,
        StateManager_1.TransitionStep.AnimNewIn,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Animate out old state and then animate in new state with assets loaded in between.
     * @description Steps:
     * 1. AnimCurrentOut
     * 2. RemoveCurrent
     * 3. UnloadAssets
     * 4. LoadAssets
     * 5. AttachNewInFront
     * 6. AnimNewIn
     * 7. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_SEQUENTIAL_MID_ASSETS = [
        StateManager_1.TransitionStep.AnimCurrentOut,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewInFront,
        StateManager_1.TransitionStep.AnimNewIn,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Animates the new state in front of the old one.
     * @description Steps:
     * 1. LoadAssets
     * 2. AttachNewInFront
     * 3. AnimNewIn
     * 4. RemoveCurrent
     * 5. UnloadAssets
     * 6. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_NEW_IN_FRONT = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewInFront,
        StateManager_1.TransitionStep.AnimNewIn,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Creates the new state behind the current one and then animates out the current state.
     * @description Steps:
     * 1. LoadAssets
     * 2. AttachNewBehind
     * 3. AnimCurrentOut
     * 4. RemoveCurrent
     * 5. UnloadAssets
     * 6. AnimNewIn
     * 7. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_OLD_OUT_REVEAL = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewBehind,
        StateManager_1.TransitionStep.AnimCurrentOut,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.AnimNewIn,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Animates in the new state and animates out the old state with the new state being behind the old one.
     * @description Steps:
     * 1. LoadAssets
     * 2. AttachNewBehind
     * 3. AnimSimultaneously
     * 4. RemoveCurrent
     * 5. UnloadAssets
     * 6. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_SIMULTANEOUSLY_NEW_BEHIND = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewBehind,
        StateManager_1.TransitionStep.AnimSimultaneously,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    /**
     * Animates in the new state and animates out the old state with the new state being in front of the old one.
     * @description Steps:
     * 1. LoadAssets
     * 2. AttachNewInFront
     * 3. AnimSimultaneously
     * 4. RemoveCurrent
     * 5. UnloadAssets
     * 6. UnloadUnusedAssets
     */
    StateToken.TRANSITION_ANIM_SIMULTANEOUSLY_NEW_IN_FRONT = [
        StateManager_1.TransitionStep.LoadAssets,
        StateManager_1.TransitionStep.AttachNewInFront,
        StateManager_1.TransitionStep.AnimSimultaneously,
        StateManager_1.TransitionStep.RemoveCurrent,
        StateManager_1.TransitionStep.UnloadAssets,
        StateManager_1.TransitionStep.UnloadUnusedAssets,
    ];
    return StateToken;
}());
exports.StateToken = StateToken;
//# sourceMappingURL=StateToken.js.map